/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Hint_PanInputs */

const en_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pan`)
};

const ar_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحريك`)
};

const bn_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্যান`)
};

const de_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschieben`)
};

const es_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mover`)
};

const fr_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`déplacer`)
};

const pt_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mover`)
};

const zh_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平移`)
};

const tr_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`taşıma`)
};

const ru_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`перемещение`)
};

const pl_image_inspector_hint_pan = /** @type {(inputs: Image_Inspector_Hint_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przesuwanie`)
};

/**
* | output |
* | --- |
* | "pan" |
*
* @param {Image_Inspector_Hint_PanInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_hint_pan = /** @type {((inputs?: Image_Inspector_Hint_PanInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Hint_PanInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_hint_pan(inputs)
	if (locale === "bn") return bn_image_inspector_hint_pan(inputs)
	if (locale === "de") return de_image_inspector_hint_pan(inputs)
	if (locale === "es") return es_image_inspector_hint_pan(inputs)
	if (locale === "fr") return fr_image_inspector_hint_pan(inputs)
	if (locale === "pt") return pt_image_inspector_hint_pan(inputs)
	if (locale === "zh") return zh_image_inspector_hint_pan(inputs)
	if (locale === "tr") return tr_image_inspector_hint_pan(inputs)
	if (locale === "ru") return ru_image_inspector_hint_pan(inputs)
	if (locale === "pl") return pl_image_inspector_hint_pan(inputs)
	return en_image_inspector_hint_pan(inputs)
});